import * as d3 from 'd3';

const oldPastelColors = [
  '#F7977A',
  '#F9AD81',
  '#FDC68A',
  '#FFF79A',
  '#C4DF9B',
  '#A2D39C',
  '#82CA9D',
  '#7BCDC8',
  '#6ECFF6',
  '#7EA7D8',
  '#8493CA',
  '#8882BE',
  '#A187BE',
  '#BC8DBF',
  '#F49AC2',
  '#F6989D',
];

// Keep in sync with benchling/lib/core/color.py
export const defaultPastelColor = '#C7B0E3';
export const pastelBlue = '#84B0DC';
const pastelColors = [
  '#F58A5E',
  '#FAAC61',
  '#FFEF86',
  '#F8D3A9',
  '#B1FF67',
  '#75C6A9',
  '#B7E6D7',
  '#85DAE9',
  pastelBlue,
  '#9EAFD2',
  defaultPastelColor,
  '#FF9CCD',
  '#D6B295',
  '#D59687',
  '#B4ABAC',
  '#C6C9D1',
];

export function hslTupleToCSSAttr(
  hue: number | string,
  darkness: number | string,
  saturation: number | string
): string {
  return `hsl(${hue},${darkness}%,${saturation}%)`;
}

function randomPastelColor(): string {
  const idx = Math.floor(Math.random() * pastelColors.length);
  return pastelColors[idx];
}

function stringToIndex(str: string, len: number): number {
  // Port of Java hash function.
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  // Mod to length, handle negative idx.
  return ((hash % len) + len) % len;
}

function stringToPastelColor(str: string): string {
  const idx = stringToIndex(str, pastelColors.length);
  return pastelColors[idx];
}

// Calculates an HSL color based on @str with luminosity @l (0 is black, 1 is white).
function stringToColor(str: string, l: number): string {
  const h = stringToIndex(str, 360);
  return d3.hsl(h, 1, l).formatHex();
}

// for index-based labeling
const shuffledPastelColors: Array<string> = [];
const iterable = [0, 1, 2, 3];
for (let k = 0; k < iterable.length; k++) {
  const i = iterable[k];
  const iterable1 = [0, 1, 2, 3];
  for (let i1 = 0; i1 < iterable1.length; i1++) {
    const j = iterable1[i1];
    shuffledPastelColors.push(pastelColors[i + 4 * j]);
  }
}

export {
  pastelColors,
  oldPastelColors,
  randomPastelColor,
  shuffledPastelColors,
  stringToPastelColor,
  stringToColor,
};
